export enum ElementAlign {
    Top,
    Left,
    Right,
    Bottom,
    Center,
    Middle // Y axis
}
